var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showAskBid)?_c('AskBidMod',{attrs:{"stock":_vm.stock,"context":_vm.context}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }